export default "__VITE_ASSET__jVWM0bzO__"